<template>
  <b-sidebar
    :visible="isAssignPartnerSidebarActive"
    bg-variant="white"
    shadow
    right
    backdrop
    no-header
    sidebar-class="sidebar-lg"
    @change2="(val) => $emit('update:is-assign-partner-sidebar-active', val)"
    @change="handleChangeSidebar"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Assign / Update Partner</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>
      <div class="p-2">
        <b-form-group label="Choose Partner">
          <v-select id="tempPartner" :options="partners" v-model="tempPartnerId" />
        </b-form-group>
        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="handleUpdatePartner"
          size="large"
          block
          >{{ isLoading ? "Loading..." : "Assign / Change Partner" }}</b-button
        >
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import { BSidebar, BFormGroup, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import useVerifications from "./useVerifications";
import { ref, watch, computed } from "@vue/composition-api";
import axios from "axios";
export default {
  components: {
    BSidebar,
    BFormGroup,
    BButton,
    vSelect,
  },
  data() {
    return {
      isUpdating: false,
    };
  },
  props: {
    isAssignPartnerSidebarActive: {
      type: Boolean,
      required: true,
    },
    verificationId: {
      type: String,
      required: true,
    },
    partnerId: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isLoading = ref(false);
    const { partners, tempPartnerId } = useVerifications();

    const handleChangeSidebar = (val) => {
      tempPartnerId.value = "";
      emit("update:is-assign-partner-sidebar-active", val);
    };

    const handleUpdatePartner = async () => {
      if (tempPartnerId.value) {
        try {
          const formData = new FormData();
          formData.append("partnerId", tempPartnerId.value.value);
          formData.append("verificationId", props.verificationId);

          isLoading.value = true;
          const res = await axios.post("/verification/assignPartner", formData);
          isLoading.value = false;

          emit("refetch-data");
          emit("update:is-assign-partner-sidebar-active", false);
        } catch (e) {
          isLoading.value = false;
          alert(e.response.data.message || e.message);
        }
      } else {
        alert("please choose partner to assign");
      }
    };

    return {
      partners,
      tempPartnerId,
      handleChangeSidebar,
      handleUpdatePartner,
      isLoading,
    };
  },
};
</script>
